import './Login.scss'
import logo from '../../../assets/images/logo.svg';
import message_icon_blue from '../../../assets/images/message-icon-blue.svg';
import lock_icon_blue from "../../../assets/images/lock-icon-blue.svg";
import { useDispatch } from 'react-redux';
import { setMe, setToken } from '../../../store/actions/authActions';
import authService from '../../../Axios/services/auth.service';
import UsersService from '../../../Axios/services/users.service';
import { Fragment, useState, useRef, useEffect } from 'react';
import { Loader } from '../../core/Loader/Loader';

interface initialStateI {
  email: string;
  password: string;
  isEmailVerified: boolean | string;
  isPendingMobile: boolean;
  errorEmailVerified: boolean;
  errorLogin: boolean;
  errorMessage: string;
  resetPassword: boolean;
  resetPasswordMSG: string;
}

const initialState: initialStateI = {
  email: "",
  password: "",
  isEmailVerified: false,
  isPendingMobile: false,
  errorEmailVerified: false,
  errorLogin: false,
  errorMessage: "",
  resetPassword: false,
  resetPasswordMSG: "",
};

const Login = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);
  const [isLoading , setIsLoading] = useState(false);
  const passwordInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (state.isEmailVerified && !state.isPendingMobile && passwordInputRef.current) {
      passwordInputRef.current.focus();
    }
  }, [state.isEmailVerified, state.isPendingMobile]);

  const continueToLogin = () => {
    setState({
      ...state,
      isPendingMobile: false,
    });
  };

  const isEmailVerified = async (email: string) => {
    try {
      setIsLoading(true);
      const isEmailVerified = await authService.isEmailVerified(email.trim());

      setIsLoading(false);

      switch (isEmailVerified) {
        case true:
          setState({
            ...state,
            isEmailVerified,
            errorEmailVerified: false,
          });
          break;
        case "pendingMobile":
          setState({
            ...state,
            isEmailVerified: true,
            isPendingMobile: true,
            errorEmailVerified: false,
          });
          break;
        case false:
          setState({
            ...state,
            errorEmailVerified: true,
          });
          break;
        default:
          //
          break;
      }
    } catch (err) {
      setIsLoading(false);
      setState({ ...state,  errorEmailVerified: true });
      console.error(err);
    }
  };

  const handleLogin = async (password: string) => {
    try {
      setIsLoading(true);
      setState({ ...state, errorLogin: false });
      dispatch(setMe(null));
      const data = await authService.login(state.email.trim(), password);
      setIsLoading(false);
      setState({ ...state, errorLogin: false });
      dispatch(setToken(data.access_token));
      console.log("call big sur function/webView");
    } catch (err) {
      setIsLoading(false);
      setState({ ...state, errorLogin: true });
      console.error(err);
    }
  };

  const handleChange = (prop: Partial<initialStateI>) => {
    setState({ ...state, ...prop });
  };

  const resetPassword = async (uid: any) => {
    try {
      await UsersService.resetpassword(uid.trim());
      setState({
        ...state,
        resetPassword: true,
        resetPasswordMSG: "Reset password URL sent to your mailbox successfully",
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="login-screen">
      <div className="triangle"></div>
      <div className="main-title"></div>
      <div className="box">
        <img src={logo} className="logo" alt={""} />
        {state.errorEmailVerified || state.errorLogin ? (
          <Fragment>
            <div className="title h1">SORRY!</div>
          </Fragment>
        ) : (
          <h1 className="title">Welcome</h1>
        )}
        <div className="note-wrapper">
          <p className="note my-3 mx-3">{state.isEmailVerified === true ? "Please enter your one time code" : "To login please enter your email address"}</p>
        </div>
        {!isLoading ? (
          <Fragment>
            <div>
              <div className="input-wrapper mb-3">
                <input
                  disabled={state.isEmailVerified === true}
                  value={state.email}
                  onChange={(e) => handleChange({ email: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !state.isEmailVerified && state.email.trim()) {
                      isEmailVerified(state.email);
                    }
                  }}
                  type="text"
                  className={"input" + (state.errorEmailVerified ? " wrong " : "")}
                  name="email"
                  placeholder="email"
                />
                <div className="i-wrapper">
                  <img src={message_icon_blue} className="" alt="" />
                </div>
              </div>
              {state.errorEmailVerified ? (
                <div className="mb-3">
                  <div className="text-left alert-danger mb-2">Sorry! This email address does not belong to a Hartman Connect user.</div>
                  <div className="text-left">Please enter the email address where you received an invitation to Connect or contact connectapp@shi.org.il</div>
                </div>
              ) : null}
            </div>
            {!state.isEmailVerified ? (
              <Fragment>
                <button className="button mb-3" onClick={() => isEmailVerified(state.email)}>
                  Next
                </button>
              </Fragment>
            ) : !state.isPendingMobile ? (
              <Fragment>
                <div className="input-wrapper mb-3">
                  <input
                    ref={passwordInputRef}
                    value={state.password}
                    onChange={(e) => handleChange({ password: e.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && state.password.trim()) {
                        handleLogin(state.password);
                      }
                    }}
                    type="text"
                    className={"input" + (state.errorLogin ? " wrong " : "")}
                    placeholder="One time code"
                  />
                  <div className="i-wrapper">
                    <img src={lock_icon_blue} alt="" />
                  </div>
                </div>

                {state.errorLogin ? (
                  <div className="alert alert-danger mb-3">
                    {!state.resetPassword ? (
                      <div className="alert alert-danger mb-3">
                        Login was not successful, <br />
                        please re-enter your one time code.
                        {/*<p className="note note-span pointer a-hover" onClick={() => resetPassword(state.email)}>Reset Password</p>*/}
                      </div>
                    ) : null}
                    {state.resetPasswordMSG !== "" ? (
                      <div className="alert alert-success mb-3">
                        <p className="note note-span">{state.resetPasswordMSG}</p>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <button className="button mb-3" onClick={() => handleLogin(state.password)}>
                  Sign In
                </button>
                {state.isEmailVerified === true && !state.errorLogin && <div className="mt-1 alert-success">{"Please check your inbox for an email with your One time code."}</div>}
              </Fragment>
            ) : (
              <Fragment>
                <div className="primary alert-primary mb-3 text-left">This is your first time logging in to Connect. Please check your inbox for an email with your password.</div>
                <div className="text-left">Didn't receive an email? Contact connectapp@shi.org.il</div>
                <button className="button mb-3" onClick={() => continueToLogin()}>
                  Next
                </button>
              </Fragment>
            )}
          </Fragment>
        ) : (
          <div className="d-flex w-100 my-3 justify-content-center align-items-center">
            <Loader />
          </div>
        )}
        {/* <p className="note note-span pointer a-hover">Need Help?</p> */}
      </div>
    </div>
  );
};

export default Login;